<template>
  <div style="min-height: 85vh; overflow: hidden">
    <div class="el-icon-s-home">
      <span style="font-size: 15px;">{{routeName}}</span>
    </div>
    <hr style="border: 1px dashed #000">
    <div style="display: flex; flex-wrap: wrap;">
      <div v-for="item in data" :key="item.id" class="file-item-container" :class="{'file-item-container-none': item.type !== 128}">
        <div v-if="item.type === 128" class="file-item" @click="read(item.id)">
          <div class="el-icon-document"/>
          <div class="file-name">{{item.name}}</div>
        </div>
      </div>
    </div>
    <a ref="fileDownLoad" target="_blank" download="1" href="#"/>
  </div>
</template>
<script>
  export default {
    name: "PanMobileList",
    data() {
      return {
        routeName: "$:我的资料",
        parentId: 0,
        data: [],
      };
    },
    mounted() {
      this.getData();
    },
    methods: {
      getData() {
        this.parentId = this.$route.query.id;
        let params = {
          parentId: this.parentId,
        };
        this.$http.get("basic", "pans/exclusive", params).then((resp) => {
          this.routeName = `$: ${resp.fileName}`;
          this.data = resp.panVOS;
        });
      },
   
      // downLoad(id) {
      //   // let url = window.config.basicServerHttpUrl + "pans/downLoadFile?id=" + id;
      //   // this.$refs.fileDownLoad.href = url;
      //   // this.$refs.fileDownLoad.click();
      // },
      read(id) {
        window.open("#/pdf?id=" + id);
      },
    },
  };
</script>
<style lang="scss" scoped>
.el-icon-s-home{
  margin: 15px 20px;
  font-size: 18px;
  cursor: pointer
  span{
    font-size: 16px;
  }
}
.file-item-container{
  width: 50%;
  padding: 10px;
  box-sizing: border-box;
  &.file-item-container-none{
    display: none;
  }
}
.file-item{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  cursor: pointer;
  padding: 10px;
  width: 100%;
  box-sizing: border-box;
  height: 100%;
  font-size: 14px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  .el-icon-document{
    font-size: 40px;
    color: #000;
    margin: 0 auto;
    margin-bottom: 10px;
  }
  .file-name{
    font-size: 14px;
  }
}
</style>
